import React from 'react'
import { PricingPlan } from '../types'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import { PricingPlanElement } from '../pricingPlan'
import { Typography } from '@mui/material'
import './migratePricingPlanModal.scss'
import ActionButton from 'uiComponents/buttons'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import { LucideIcon } from 'utils/lucideIcon'
import { useTranslation } from 'translations'

interface MigratePricingPlanModalProps {
    migratingPricingPlan: PricingPlan
    activePricingPlan: PricingPlan
    onMigrate: () => void
    onDismiss: () => void
}

export const MigratePricingPlanModal = ({
    migratingPricingPlan,
    activePricingPlan,
    onMigrate,
    onDismiss,
}: MigratePricingPlanModalProps) => {
    const { t } = useTranslation()
    const migrationDetails = (() => {
        const activePricingPlanAnnualPlan = activePricingPlan.paymentPlans.find((plan) => plan.paymentInterval === 'P1Y')
        const activePricingPlanMonthlyPlan = activePricingPlan.paymentPlans.find((plan) => plan.paymentInterval === 'P1M')
        const migratingPaymentPlanAnnualPlanMembers = migratingPricingPlan.paymentPlans.find((plan) => plan.paymentInterval === 'P1Y')?.memberCount ?? 0
        const migratingPaymentPlanMonthlyPlanMembers = migratingPricingPlan.paymentPlans.find((plan) => plan.paymentInterval === 'P1M')?.memberCount ?? 0

        if (activePricingPlanAnnualPlan && activePricingPlanMonthlyPlan) {
            return t('products.pricing.pricingPlans.migrateModal.allMembers', {
                memberCount: migratingPaymentPlanAnnualPlanMembers + migratingPaymentPlanMonthlyPlanMembers,
            })
        } else if (activePricingPlanAnnualPlan) {
            return t('products.pricing.pricingPlans.migrateModal.annualMembers', {
                memberCount: migratingPaymentPlanAnnualPlanMembers,
            })
        }
        return t('products.pricing.pricingPlans.migrateModal.monthlyMembers', {
            memberCount: migratingPaymentPlanMonthlyPlanMembers,
        })
    })()

    return (
        <Modal
            title={t('products.pricing.pricingPlans.migrateModal.title')}
            onDismiss={onDismiss}
            className="migrate-pricing-plan-modal"
        >
            <ModalBody>
                <Typography variant="body1">
                    {t('products.pricing.pricingPlans.migrateModal.body')}
                    <br /><br />
                    {t('products.pricing.pricingPlans.migrateModal.bodyStop')}
                </Typography>
                <div className="pricing-plan-container">
                    <label className="plan-label">{t('products.pricing.pricingPlans.migrateModal.from')}</label>
                    <PricingPlanElement pricingPlan={migratingPricingPlan} readOnly />
                    <div className="migration-details">
                        <Typography variant="body1">{migrationDetails}</Typography> <LucideIcon iconName="ArrowDown" />
                    </div>
                    <label className="plan-label">{t('products.pricing.pricingPlans.migrateModal.to')}</label>
                    <PricingPlanElement pricingPlan={activePricingPlan} readOnly />
                </div>
            </ModalBody>
            <ModalFooter>
                <CancelButton onClick={onDismiss} size="large" />
                <ActionButton size="large" onClick={onMigrate}>
                    {t('products.pricing.pricingPlans.migrateModal.button')}
                </ActionButton>
            </ModalFooter>
        </Modal>
    )
}
